<template>
  <el-container v-title data-title="发送消息" style="min-height:98vh">
    <el-header style="text-align: right; font-size: 12px; height: 105px; background-image: linear-gradient(to right, white , green);">
      <Top/>
    </el-header>
    <el-container>
      <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
        <Menu @GoTo='goto'></Menu>
      </el-aside>
      <el-main style="width: 1px">
        <el-header style="height: auto; padding: 0; background-color: #FFF">
          <el-container>
            <el-header height="20px" style="padding: 0; background-color: #FFF">
              <el-breadcrumb separator="/">
                <el-breadcrumb-item>消息管理</el-breadcrumb-item>
                <el-breadcrumb-item>发送消息</el-breadcrumb-item>
              </el-breadcrumb>
            </el-header>
            <el-main>
              <el-form ref="addForm" :inline="true" :model="addData" :rules="rules" class="demo-form-inline" >
                <el-form-item label="学校">
                  <el-select v-model="addData.schoolId" @change="handleSchoolChange" filterable>
                    <el-option v-for="(item, index) in schoolList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="消息类型" prop="type">
                  <el-select v-model="addData.type" placeholder="请选择" @change="handleSearch">
                    <el-option label="按班级发给学生的家长" value="1"></el-option>
                    <el-option label="按教职员分组发给教职员" value="2"></el-option>
                    <el-option label="发送给指定教职员" value="3"></el-option>
                    <el-option label="发送给指定学生的家长" value="4"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="定时发送时间">
                  <el-date-picker
                    v-model="addData.scheduleTime"
                    type="datetime"
                    placeholder="选择定时发送时间"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="checkDate"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="班级" v-show="['3', '4'].indexOf(addData.type) >= 0">
                  <el-select v-model="addData.classId" @change="addData.checkedStaffList=[];addData.checkedStudentList=[]">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in classList" :key="index" :label="item.name" :value="item.id"></el-option>
                  </el-select>
                </el-form-item>
                <br>
                <el-form-item>
                  <el-checkbox-button v-model="toggleSelectValue" v-show="addData.showClassList && classList != null && classList.length > 0
                    || addData.showStaffGroupList && staffGroupList != null && staffGroupList.length > 0
                    || addData.showStaffList && selectingStaffList != null && selectingStaffList.length > 0
                    || addData.showStudentList && selectingStudentList != null && selectingStudentList.length > 0" @change="toggleSelect">全选</el-checkbox-button>
                </el-form-item>
                <br>
                <el-form-item v-show="addData.showClassList">
                  <el-checkbox-group v-model="addData.checkedClassList">
                    <el-checkbox-button v-for="classInfo in classList" :label="classInfo" :key="classInfo.id">{{classInfo.name}}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item v-show="addData.showStaffGroupList">
                  <el-checkbox-group v-model="addData.checkedStaffGroupList">
                    <el-checkbox-button v-for="staffGroup in staffGroupList" :label="staffGroup" :key="staffGroup.id">{{staffGroup.name}}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item v-show="addData.showStaffList">
                  <el-checkbox-group v-model="addData.checkedStaffList">
                    <el-checkbox-button v-for="staff in selectingStaffList" :label="staff" :key="staff.id">{{staff.realName}}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
                <el-form-item v-show="addData.showStudentList">
                  <el-checkbox-group v-model="addData.checkedStudentList">
                    <el-checkbox-button v-for="student in selectingStudentList" :label="student" :key="student.id">{{student.realName}}</el-checkbox-button>
                  </el-checkbox-group>
                </el-form-item>
                <br>
                <el-form-item v-show="addData.type != null" :label="contentTitle" :required="true" prop="content" class="messageContentBox">
                  <el-input type="textarea" :rows="5" placeholder="请输入内容" maxlength="250" v-model="addData.content"></el-input>
                </el-form-item>
                <br>
                <el-form-item>
                  <el-button v-show="addData.type != null" type="primary" :loading="isSending" @click="sendCustomMessage('1', false, false, false)">发送消息</el-button>
                  <!-- <el-button v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin && ['2', '3'].indexOf(addData.type) >= 0" v-show="addData.type != null" type="primary" :loading="isSending" @click="sendCustomMessage('2', false, false, false)">发送短信</el-button> -->
                  <el-button v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin && (['2', '3'].indexOf(addData.type) >= 0 || userInfo.schoolIdList != null && (userInfo.schoolIdList.includes(23) || userInfo.schoolIdList.includes(54)) || userInfo.schoolIdList.includes(15))" v-show="addData.type != null" type="primary" :loading="isSending" @click="sendCustomMessage('2', false, false, false)">发送短信</el-button>
                  <el-button v-if="['1'].indexOf(userInfo.userType) != -1" v-show="addData.type != null && ['1', '4'].indexOf(addData.type) != -1" type="primary" :loading="isSending" @click="sendCustomMessage('1', true, false, false)">发送欠费消息</el-button>
                  <!-- <el-button v-if="['1'].indexOf(userInfo.userType) != -1" v-show="addData.type != null && ['1', '4'].indexOf(addData.type) != -1" type="primary" :loading="isSending" @click="sendCustomMessage('2', true, false, false)">发送欠费短信</el-button> -->
                  <el-button v-if="['1'].indexOf(userInfo.userType) != -1 || userInfo.isFacultyAdmin && userInfo.schoolIdList.includes(23)" v-show="addData.type != null && ['1', '4'].indexOf(addData.type) != -1" type="primary" :loading="isSending" @click="sendCustomMessage('2', true, false, false)">发送欠费短信</el-button>
                  <el-button v-if="['1'].indexOf(userInfo.userType) != -1" v-show="addData.type != null && ['1', '4'].indexOf(addData.type) != -1" type="primary" :loading="isSending" @click="sendCustomMessage('2', false, true, false)">发送未绑定短信（全部）</el-button>
                  <el-button v-if="['1'].indexOf(userInfo.userType) != -1" v-show="addData.type != null && ['1', '4'].indexOf(addData.type) != -1" type="primary" :loading="isSending" @click="sendCustomMessage('2', false, false, true)">发送未绑定短信（首个）</el-button>
                </el-form-item>
              </el-form>
            </el-main>
          </el-container>
        </el-header>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Top from './Top.vue'
import Menu from './Menu.vue'
export default ({
  components: {
    Menu,
    Top
  },
  data () {
    return {
      userInfo: {},
      addData: {
        showClassList: false,
        checkedClassList: [],
        showStaffGroupList: false,
        checkedStaffGroupList: [],
        showStaffList: false,
        checkedStaffList: [],
        showStudentList: false,
        checkedStudentList: [],
        schoolId: '',
        classId: '',
        scheduleTime: ''
      },
      schoolList: [],
      classList: [],
      studentList: [],
      staffGroupList: [],
      staffList: [],
      rules: {
        content: [{ required: true, message: '请填写消息内容', trigger: 'blur' }]
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 86400000
        },
        selectableRange: '00:00:00 - 23:59:59'
      },
      toggleSelectValue: false,
      isSending: false
    }
  },
  mounted () {
    if (this.Cookie.get('userInfo') !== undefined && this.Cookie.get('userInfo') !== '') {
      this.userInfo = JSON.parse(this.Cookie.get('userInfo'))
    }
    // this.getClassList()
    // this.getStaffGroupList()
    // this.getStaffList()
    // this.getStudentList()
    this.getSchoolList()
  },
  methods: {
    goto (url) {
      if (url === this.$route.path) return
      this.$router.push(url)
    },
    handleSearch () {
      this.addData.showClassList = false
      this.addData.checkedClassList = []
      this.addData.showStaffGroupList = false
      this.addData.checkedStaffGroupList = []
      this.addData.showStaffList = false
      this.addData.checkedStaffList = []
      this.addData.showStudentList = false
      this.addData.checkedStudentList = []
      // if (this.addData.type === null) {
      //   this.addData.showClassList = false
      //   this.addData.classList = []
      //   this.addData.showStaffGroupList = false
      //   this.addData.checkedStaffGroupList = []
      //   this.addData.showStaffList = false
      //   this.addData.checkedStaffList = []
      //   this.addData.showStudentList = false
      //   this.addData.checkedStudentList = []
      // } else {
      switch (this.addData.type) {
        case '1':
          this.addData.showClassList = true
          // this.addData.showStaffGroupList = false
          // this.addData.checkedStaffGroupList = []
          // this.addData.showStaffList = false
          // this.addData.checkedStaffList = []
          // this.addData.showStudentList = false
          // this.addData.checkedStudentList = []
          break
        case '2':
          this.addData.showStaffGroupList = true
          // this.addData.showClassList = false
          // this.addData.checkedClassList = []
          // this.addData.showStaffList = false
          // this.addData.checkedStaffList = []
          // this.addData.showStudentList = false
          // this.addData.checkedStudentList = []
          break
        case '3':
          this.addData.showStaffList = true
          // this.addData.showClassList = false
          // this.addData.checkedClassList = []
          // this.addData.showStaffGroupList = false
          // this.addData.checkedStaffGroupList = []
          // this.addData.showStudentList = false
          // this.addData.checkedStudentList = []
          break
        case '4':
          this.addData.showStudentList = true
          // this.addData.showClassList = false
          // this.addData.checkedClassList = []
          // this.addData.showStaffGroupList = false
          // this.addData.checkedStaffGroupList = []
          // this.addData.showStaffList = false
          // this.addData.checkedStaffList = []
          break
        default:
      }
      // }
    },
    getClassList () {
      let _this = this
      if (_this.addData.schoolId === '') {
        _this.classList = []
        return
      }
      this.$axios.post(this.GLOBAL.host + '/class/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: _this.addData.schoolId,
          filterNotGraduated: true
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.classList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getStaffGroupList () {
      let _this = this
      if (_this.addData.schoolId === '') {
        _this.staffGroupList = []
        return
      }
      this.$axios.post(this.GLOBAL.host + '/staff/group/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: _this.addData.schoolId
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.staffGroupList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getStaffList () {
      let _this = this
      if (_this.addData.schoolId === '') {
        _this.staffList = []
        return
      }
      this.$axios.post(this.GLOBAL.host + '/user/listStaff',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: _this.addData.schoolId
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.staffList = res.data.data
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    getStudentList () {
      let _this = this
      if (_this.addData.schoolId === '') {
        _this.studentList = []
        return
      }
      this.$axios.post(this.GLOBAL.host + '/user/listStudent',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id,
          schoolId: _this.addData.schoolId,
          simpleFormat: true
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.studentList = res.data.data.list
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    sendCustomMessage (sendType, sendForUnpaid, sendForUnbindingAll, sendForUnbindingFirstOne) {
      let _this = this
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          let params = {
            currentUserId: _this.userInfo.id,
            schoolId: _this.addData.schoolId,
            type: _this.addData.type,
            sendType: sendType,
            sendForUnpaid: sendForUnpaid,
            sendForUnbindingAll: sendForUnbindingAll,
            sendForUnbindingFirstOne: sendForUnbindingFirstOne,
            targetList: [],
            content: _this.addData.content,
            scheduleTime: _this.addData.scheduleTime
          }
          switch (_this.addData.type) {
            case '1':
              this.addData.checkedClassList.forEach(classInfo => {
                params.targetList.push(classInfo.id)
              })
              break
            case '2':
              this.addData.checkedStaffGroupList.forEach(staffGroup => {
                params.targetList.push(staffGroup.id)
              })
              break
            case '3':
              this.addData.checkedStaffList.forEach(staff => {
                params.targetList.push(staff.id)
              })
              break
            case '4':
              this.addData.checkedStudentList.forEach(student => {
                params.targetList.push(student.id)
              })
              break
            default:
              break
          }
          if (params.targetList.length === 0) {
            this.$message({
              type: 'error',
              message: '请选择消息发送对象'
            })
            return
          }
          _this.isSending = true
          this.$axios.post(this.GLOBAL.host + '/sendCustomMessage', params).then(res => {
            if (res.data != null && res.data.status === 200) {
              _this.addData.content = ''
              this.$message.success(res.data.message)
            } else {
              this.$message.error(res.data.message)
            }
            _this.isSending = false
          })
        }
      })
    },
    getSchoolList () {
      let _this = this
      this.$axios.post(this.GLOBAL.host + '/school/list',
        this.$qs.stringify({
          currentUserId: _this.userInfo.id
        })
      ).then(res => {
        if (res.data != null) {
          if (res.data.status === 200) {
            _this.schoolList = res.data.data.list
            if (_this.schoolList.length > 0) {
              _this.addData.schoolId = _this.schoolList[0].id
              _this.handleSchoolChange()
            }
          } else {
            this.$message.error(res.data.message)
          }
        }
      })
    },
    handleSchoolChange () {
      if (this.addData.type != null) this.addData.type = null
      this.handleSearch()
      this.getClassList()
      this.getStaffGroupList()
      this.getStaffList()
      this.getStudentList()
    },
    toggleSelect (checked) {
      switch (this.addData.type) {
        case '1':
          this.addData.checkedClassList = []
          if (checked) {
            this.classList.forEach(classInfo => {
              this.addData.checkedClassList.push(classInfo)
            })
          }
          break
        case '2':
          this.addData.checkedStaffGroupList = []
          if (checked) {
            this.staffGroupList.forEach(staffGroup => {
              this.addData.checkedStaffGroupList.push(staffGroup)
            })
          }
          break
        case '3':
          this.addData.checkedStaffList = []
          if (checked) {
            this.selectingStaffList.forEach(staff => {
              this.addData.checkedStaffList.push(staff)
            })
          }
          break
        case '4':
          this.addData.checkedStudentList = []
          if (checked) {
            this.selectingStudentList.forEach(student => {
              this.addData.checkedStudentList.push(student)
            })
          }
          break
        default:
          break
      }
    },
    checkDate (time) {
      let now = new Date()
      if (new Date(time) < now) {
        this.addData.scheduleTime = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getHours()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:00`
      }
    }
  },
  computed: {
    // selectingClassList () {
    //   let tempArray = []
    //   if (this.addData.schoolId != null && this.addData.schoolId !== '') {
    //     this.classList.forEach(classInfo => {
    //       if (classInfo.schoolId === this.addData.schoolId) {
    //         tempArray.push(classInfo)
    //       }
    //     })
    //   } else {
    //     tempArray = this.classList
    //   }
    //   return tempArray
    // },
    // selectingStaffGroupList () {
    //   let tempArray = []
    //   if (this.addData.schoolId != null && this.addData.schoolId !== '') {
    //     this.staffGroupList.forEach(staffGroup => {
    //       if (staffGroup.schoolId === this.addData.schoolId) {
    //         tempArray.push(staffGroup)
    //       }
    //     })
    //   } else {
    //     tempArray = this.staffGroupList
    //   }
    //   return tempArray
    // },
    selectingStaffList () {
      let tempArray = []
      if (this.addData.classId != null && this.addData.classId !== '') {
        this.staffList.forEach(staff => {
          if (staff.classIdList != null && staff.classIdList.indexOf(this.addData.classId) > 0) {
            tempArray.push(staff)
          }
        })
      // } else if (this.addData.schoolId != null && this.addData.schoolId !== '') {
      //   this.staffList.forEach(staff => {
      //     if (staff.schoolId === this.addData.schoolId) {
      //       tempArray.push(staff)
      //     }
      //   })
      } else {
        tempArray = this.staffList
      }
      return tempArray
    },
    selectingStudentList () {
      let tempArray = []
      if (this.addData.classId != null && this.addData.classId !== '') {
        this.studentList.forEach(student => {
          if (student.classId === this.addData.classId) {
            tempArray.push(student)
          }
        })
      // } else if (this.addData.schoolId != null && this.addData.schoolId !== '') {
      //   this.studentList.forEach(student => {
      //     if (student.schoolId === this.addData.schoolId) {
      //       tempArray.push(student)
      //     }
      //   })
      } else {
        tempArray = this.studentList
      }
      return tempArray
    },
    contentTitle () {
      let usedCharacterNum = 0
      if (this.addData.content != null) {
        usedCharacterNum = this.addData.content.length
      }
      return '消息内容（剩余可输入' + (250 - usedCharacterNum) + '字）'
    },
    checkedClassList () {
      return this.addData.checkedClassList
    },
    checkedStaffGroupList () {
      return this.addData.checkedStaffGroupList
    },
    checkedStaffList () {
      return this.addData.checkedStaffList
    },
    checkedStudentList () {
      return this.addData.checkedStudentList
    }
  },
  watch: {
    // selectingClassList () {
    //   if (this.addData.classId != null && this.selectingClassList.map(item => item.id).indexOf(this.addData.classId) === -1) {
    //     this.addData.classId = ''
    //   }
    // }
    checkedClassList () {
      if (this.addData.type === '1') {
        this.toggleSelectValue = this.classList != null && this.addData.checkedClassList.length === this.classList.length
      }
    },
    checkedStaffGroupList () {
      if (this.addData.type === '2') {
        this.toggleSelectValue = this.staffGroupList != null && this.addData.checkedStaffGroupList.length === this.staffGroupList.length
      }
    },
    checkedStaffList () {
      if (this.addData.type === '3') {
        this.toggleSelectValue = this.selectingStaffList != null && this.addData.checkedStaffList.length === this.selectingStaffList.length
      }
    },
    checkedStudentList () {
      if (this.addData.type === '4') {
        this.toggleSelectValue = this.selectingStudentList != null && this.addData.checkedStudentList.length === this.selectingStudentList.length
      }
    },
    'addData.scheduleTime' (selectTime) {
      const date = new Date(new Date(selectTime).setHours(0, 0, 0, 0)).getTime()
      const today = new Date(new Date().setHours(0, 0, 0, 0)).getTime()
      const curTime = new Date()
      if (date === today) {
        this.pickerOptions.selectableRange = `${String(curTime.getHours()).padStart(2, '0')}:${String(curTime.getMinutes()).padStart(2, '0')}:${String(curTime.getSeconds()).padStart(2, '0')} - 23:59:59`
      } else {
        this.pickerOptions.selectableRange = '00:00:00 - 23:59:59'
      }
    }
  }
})
</script>
<style>
.messageContentBox, .messageContentBox .el-form-item__content {
  width: 100%
}
</style>



// WEBPACK FOOTER //
// src/components/SendMessage.vue